import styled from "styled-components";

export const Container = styled.div<{ width: string; height: string }>`
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  display: flex;
  right: 0px;
  justify-content: center;

  @media (max-width: 800px) {
    width: 100%;
  }
`;

export const Content = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
`;

export const StyledImg = styled.img`
  width: 250px;
  height: 200px;
  align-self: center;
`;

export const Title = styled.span`
  font-size: 1rem;
  font-weight: 700;
  color: black;
  margin-bottom: 4px;
`;

export const Description = styled.span`
  font-size: 0.875rem;
  color: black;
`;
